<div class="flex flex-center">
  <em class="pi pi-spin pi-spinner loader-icon"></em>
</div>
<p class="loader-msg" *ngIf="message">{{message}}</p>
